import React from 'react';

const BuyButton = ({text, cta}) => {
    return (
        <button onClick={cta ? cta() : null} className='main_buy_button'>{text} <img width={38} height={36} src={'/img/small_logo.svg'} alt={'buy $GEGG'}/></button>
    );
};

export default BuyButton;